import { DateField, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import VisuallyHiddenInput from "components/ui/atoms/VisuallyHiddenInput";
import dayjs from "dayjs";
import { useController } from "react-hook-form";

const CustomDateField = ({ field, control }) => {
  const { field: fieldProps, fieldState } = useController({
    control,
    name: field.name,
  });
  const cleanedDefaultValue = fieldProps.value ? dayjs(fieldProps.value) : null;

  const handleChange = (newValue) => {
    fieldProps.onChange(newValue ? newValue.format("YYYY-MM-DD") : null); // Format the value properly
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
      {/* VisuallyHiddenInput is used for accessibility purposes */}
      <VisuallyHiddenInput
        type="text"
        name={field.name}
        value={
          cleanedDefaultValue ? cleanedDefaultValue.format("YYYY-MM-DD") : ""
        }
        onChange={() => {}} // Just to avoid console warning
      />
      <DateField
        label={field.label}
        value={cleanedDefaultValue} // Pass the formatted value to DateField
        variant="outlined"
        format="DD/MM/YYYY"
        helperText={fieldState.error?.message || field.help_text || ""}
        disabled={field.disabled}
        sx={{ display: field.hidden ? "none" : "block" }}
        onChange={handleChange} // Pass the onChange handler
        error={!!fieldState.error}
      />
    </LocalizationProvider>
  );
};

export default CustomDateField;
